import { signal } from "@preact/signals-react"

export const elementsInLoading = signal([])
export const distributionCarouselMove = signal(false)
export const stockCarouselMove = signal(false)

export const selectedCountryPricing = signal(null)
export const selectedMarketplacePricing = signal(null)
export const skuDetailsScores = signal({})
export const skuDetailsScoresInLoading = signal([])

export const resetSkuDetails = () => {
    elementsInLoading.value = []
    distributionCarouselMove.value = false
    stockCarouselMove.value = false
    selectedCountryPricing.value = null
    selectedMarketplacePricing.value = null
    skuDetailsScores.value = {}
    skuDetailsScoresInLoading.value = []
}